import React from "react";
import styles from "./SelectMacroButton.module.css";

type Props = {
  title: string;
  onClick: (e:any) => void;
  selected: boolean;
  index: string;
};

function SelectMacroButton({ title, onClick, selected, index }: Props) {
  return (
    <button
      className={`${styles["macro-btn"]} ${
        selected && styles["macro-btn-sel"]
      }`}
      onClick={onClick}
      value={index}
    >
      {title}
    </button>
  );
}

export default SelectMacroButton;
